import { createAssociatedTokenAccountInstruction, getAccount, getAssociatedTokenAddress, TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { Connection, PublicKey, TransactionInstruction } from "@solana/web3.js";
import { getSolanaRpcUrl } from "@/lib/rpc";

export const NETWORK = getSolanaRpcUrl(); // Change to mainnet if needed
// export const NETWORK = "https://api.devnet.solana.com"; // Change to mainnet if needed
export const WERT_HOT_WALLET = new PublicKey("CYdZAb4i2oaz5CiAvwenMyUVm2DJdd2cWKsekKxxXCQX");

export const connection = new Connection(NETWORK, "confirmed");

export const getOrCreateAssociatedTokenAccountIX = async (
    connection: Connection,
    wallet: PublicKey,
    mint: PublicKey, 
) => {
    let createUserTokenAccountIX: TransactionInstruction | null = null;
    const userTokenAccount = await getAssociatedTokenAddress(
        mint,
        wallet,
        true, // allowOwnerOffCurve
        TOKEN_PROGRAM_ID
    );
    // Check if user token account exists, if not create it
    try {
        await getAccount(connection, userTokenAccount);
        console.log("User token account already exists");
    } catch {
        console.log("Creating user token account");
        createUserTokenAccountIX =
            createAssociatedTokenAccountInstruction(
                wallet, // payer
                userTokenAccount, // associated token account
                wallet, // owner
                mint, // mint
                TOKEN_PROGRAM_ID
            );
    }
    return {createUserTokenAccountIX, userTokenAccount};
};

export const dataToHexString = (data: any) => {
    const jsonString = JSON.stringify(data);
    const hexString = Buffer.from(jsonString, 'utf8').toString('hex');
    return hexString;
}